<div class="card ">
    <div class="card-header">Summary</div>
    <div class="card-body">
        <table class="table m-0" *ngIf="summaryData.length">
            <thead>
            <tr>
                <td ></td>
                <td *ngFor="let col of summaryData[0].data">{{col[0]}}</td>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let row of summaryData;">
                <td>{{row.label}}</td>
                <td *ngFor="let col of row.data">{{col[1]*100|number:'1.0-2'}}%</td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
